/**
 * Flujo unificado Agregar al carrito (PDP):
 * - Enlaza product-form con cart-drawer
 * - Botones [data-pms-atc-anchor] → click del submit principal
 * - Feedback: drawer + toast + contador
 * - Límite de stock/carrito: toast de error + aviso en buy box
 */
(function () {
  var TOAST_MS = 3200;
  var LOADING_FAILSAFE_MS = 12000;
  var DEFAULT_LIMIT_MSG = 'Tu carrito ya tiene la cantidad máxima de este artículo.';

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  function getMainProductForm() {
    return document.querySelector('product-form[data-main="true"]');
  }

  function getMainSubmitButton() {
    var form = getMainProductForm();
    if (!form) return document.querySelector('[id^="ProductSubmitButton-"]');
    return form.querySelector('#ProductSubmitButton-' + form.dataset.section) ||
      form.querySelector('[id^="ProductSubmitButton-"]') ||
      form.querySelector('[type="submit"][name="add"]');
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getLimitState() {
    if (typeof window.__pmsGetAddToCartLimitState === 'function') {
      return window.__pmsGetAddToCartLimitState();
    }
    return { allowed: true, message: '' };
  }

  function normalizeLimitMessage(message) {
    if (!message) return DEFAULT_LIMIT_MSG;
    var text = String(message).replace(/\s+/g, ' ').trim();
    if (!text) return DEFAULT_LIMIT_MSG;
    if (/all\s+\d+\s+.*are in your cart/i.test(text)) {
      return DEFAULT_LIMIT_MSG;
    }
    if (/only added/i.test(text)) {
      return 'No se pudo agregar la cantidad solicitada. Revisa el stock disponible.';
    }
    return text;
  }

  function linkProductFormCart() {
    var productForm = getMainProductForm();
    var cartDrawer = getCartDrawer();
    if (!productForm || !cartDrawer) return false;
    productForm.cart = cartDrawer;
    var submitBtn = getMainSubmitButton();
    if (submitBtn) {
      submitBtn.setAttribute('aria-haspopup', 'dialog');
    }
    return true;
  }

  function resetSubmitBusyState() {
    var submitBtn = getMainSubmitButton();
    if (!submitBtn) return;
    submitBtn.removeAttribute('aria-disabled');
    submitBtn.classList.remove('loading');
    var spinner = submitBtn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  function isSubmitDisabled() {
    var submitBtn = getMainSubmitButton();
    if (!submitBtn) return true;
    if (submitBtn.disabled) return true;
    if (submitBtn.getAttribute('aria-disabled') === 'true') return true;
    return false;
  }

  function syncAtcAnchors() {
    var disabled = isSubmitDisabled();
    document.querySelectorAll('[data-pms-atc-anchor]').forEach(function (anchor) {
      if (!anchor.classList.contains('loading')) {
        anchor.disabled = disabled;
      }
    });
  }

  function ensureToastRoot() {
    var root = document.getElementById('pms-atc-toast-root');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'pms-atc-toast-root';
    root.className = 'pms-atc-toast-root';
    root.setAttribute('aria-live', 'polite');
    root.setAttribute('aria-atomic', 'true');
    document.body.appendChild(root);
    return root;
  }

  function showToast(message, type) {
    var root = ensureToastRoot();
    var toast = document.createElement('div');
    toast.className = 'pms-atc-toast' + (type === 'error' ? ' pms-atc-toast--error' : '');
    toast.setAttribute('role', type === 'error' ? 'alert' : 'status');
    toast.textContent = message;
    root.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.remove();
      }, 300);
    }, TOAST_MS);
  }

  function showAddedToast(message) {
    showToast(message || 'Producto agregado al carrito', 'success');
  }

  function showLimitToast(message) {
    showToast(normalizeLimitMessage(message), 'error');
  }

  function revealLimitNotice(message) {
    if (typeof window.__pmsRevealStockLimitNotice === 'function') {
      window.__pmsRevealStockLimitNotice(message);
    }
  }

  function refreshLimitState() {
    if (typeof window.__pmsRefreshCartLimitState === 'function') {
      window.__pmsRefreshCartLimitState();
    }
  }

  function clearAllAnchorLoading() {
    document.querySelectorAll('[data-pms-atc-anchor].loading').forEach(function (anchor) {
      anchor.classList.remove('loading');
      anchor.disabled = false;
      var spinner = anchor.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
    syncAtcAnchors();
  }

  function setAnchorLoading(anchor, loading) {
    if (!anchor) return;
    if (loading) {
      anchor.classList.add('loading');
      anchor.disabled = true;
      var spinner = anchor.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
      window.setTimeout(function () {
        if (anchor.classList.contains('loading')) {
          setAnchorLoading(anchor, false);
          resetSubmitBusyState();
        }
      }, LOADING_FAILSAFE_MS);
    } else {
      anchor.classList.remove('loading');
      var spinnerOff = anchor.querySelector('.loading-overlay__spinner');
      if (spinnerOff) spinnerOff.classList.add('hidden');
      syncAtcAnchors();
    }
  }

  function getCartUpdateEventName() {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return PUB_SUB_EVENTS.cartUpdate;
    }
    return 'cart-update';
  }

  var lastSuccessAt = 0;
  var lastErrorAt = 0;

  function handleAddSuccess() {
    var now = Date.now();
    if (now - lastSuccessAt < 800) return;
    lastSuccessAt = now;
    showAddedToast('Producto agregado al carrito');
    clearAllAnchorLoading();
    resetSubmitBusyState();
    refreshLimitState();
  }

  function handleAddLimitError(message) {
    var now = Date.now();
    if (now - lastErrorAt < 800) return;
    lastErrorAt = now;
    var finalMessage = normalizeLimitMessage(message);
    showLimitToast(finalMessage);
    revealLimitNotice(finalMessage);
    clearAllAnchorLoading();
    resetSubmitBusyState();
    refreshLimitState();
  }

  function blockIfLimitReached() {
    var limitState = getLimitState();
    if (limitState.allowed) return false;
    handleAddLimitError(limitState.message);
    return true;
  }

  function bindCartUpdateFeedback() {
    if (window.__pmsCartFeedbackBound) return;
    if (typeof subscribe !== 'function') return;
    window.__pmsCartFeedbackBound = true;

    subscribe(getCartUpdateEventName(), function (payload) {
      if (payload && payload.source && payload.source !== 'product-form') return;
      handleAddSuccess();
    });
  }

  function parseCartAddResponse(response) {
    if (!response) return Promise.resolve(null);
    return response
      .clone()
      .json()
      .catch(function () {
        return null;
      });
  }

  function bindCartAddFetchFallback() {
    if (window.__pmsCartAddFetchBound || !window.fetch) return;
    window.__pmsCartAddFetchBound = true;

    var originalFetch = window.fetch.bind(window);
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : url && url.url ? String(url.url) : '';
      var responsePromise = originalFetch.apply(this, arguments);

      if (isProductPage() && urlStr.indexOf('/cart/add') !== -1) {
        responsePromise
          .then(function (response) {
            return parseCartAddResponse(response).then(function (data) {
              if (data && data.status) {
                handleAddLimitError(data.description || data.message);
                return;
              }
              if (!response || !response.ok) {
                handleAddLimitError(DEFAULT_LIMIT_MSG);
                return;
              }
              linkProductFormCart();
              var drawer = getCartDrawer();
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.renderContents(data);
              } else if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              }
              handleAddSuccess();
            });
          })
          .catch(function () {
            handleAddLimitError('No se pudo agregar el producto. Intenta nuevamente.');
          });
      }

      return responsePromise;
    };
  }

  function prepareBeforeAdd() {
    linkProductFormCart();
    resetSubmitBusyState();
    if (typeof window.__pmsSyncQuantityBeforeAtc === 'function') {
      window.__pmsSyncQuantityBeforeAtc();
    }
  }

  function bindMainFormSubmit() {
    if (window.__pmsMainFormSubmitBound) return;
    window.__pmsMainFormSubmitBound = true;

    document.addEventListener(
      'submit',
      function (event) {
        if (!isProductPage()) return;
        var form = event.target;
        if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        var productForm = form.closest('product-form[data-main="true"]');
        if (!productForm) return;
        var submitter = event.submitter;
        if (submitter && submitter.getAttribute('data-skip-cart-button') === 'true') return;

        prepareBeforeAdd();
        if (blockIfLimitReached()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function bindAnchorClicks() {
    if (window.__pmsAtcAnchorClickBound) return;
    window.__pmsAtcAnchorClickBound = true;

    document.addEventListener('click', function (event) {
      var anchor = event.target.closest('[data-pms-atc-anchor]');
      if (!anchor || anchor.classList.contains('loading')) return;

      if (anchor.disabled) {
        if (!isSubmitDisabled()) {
          anchor.disabled = false;
        } else {
          handleAddLimitError('Este producto no está disponible en este momento.');
          return;
        }
      }

      var mainSubmit = getMainSubmitButton();
      if (!mainSubmit || mainSubmit.disabled) {
        handleAddLimitError('Este producto no está disponible en este momento.');
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      prepareBeforeAdd();
      if (blockIfLimitReached()) return;

      setAnchorLoading(anchor, true);
      mainSubmit.click();
    });
  }

  function observeSubmitButton() {
    var submitBtn = getMainSubmitButton();
    if (!submitBtn || submitBtn.dataset.pmsAtcObserved === 'true') return;
    submitBtn.dataset.pmsAtcObserved = 'true';

    new MutationObserver(function () {
      syncAtcAnchors();
      if (!submitBtn.classList.contains('loading') && submitBtn.getAttribute('aria-disabled') !== 'true') {
        clearAllAnchorLoading();
      }
    }).observe(submitBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  }

  function init() {
    if (!isProductPage()) return;
    linkProductFormCart();
    syncAtcAnchors();
    observeSubmitButton();
    bindMainFormSubmit();
    bindAnchorClicks();
    bindCartUpdateFeedback();
    bindCartAddFetchFallback();
    refreshLimitState();
  }

  function tryInit() {
    init();
    if (!window.__pmsCartFeedbackBound) {
      bindCartUpdateFeedback();
    }
    if (!window.__pmsCartAddFetchBound) {
      bindCartAddFetchFallback();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-form').then(tryInit);
    customElements.whenDefined('cart-drawer').then(tryInit);
  }

  document.addEventListener('shopify:section:load', tryInit);
})();
